/* c-video.js — a poster that becomes a player on click.

   The player waits in a <template> so a rail of six cards does not pull six
   videos on load; the first click swaps it in. While it runs the media box
   marks itself, so the frame's own furniture — a play mark, an overlay, a
   product bar — can step out of the way in CSS and step back in on pause.

   Markup contract:
     <div data-video>
       …poster…
       <template data-video-player><video …>|<iframe …></template>
     </div>
     <button type="button" data-video-play>…</button>

   The button may sit inside the media box or anywhere else in the same card:
   the nearest ancestor holding a [data-video] wins, so a play mark drawn on a
   scrim *over* the video finds it too. */
(function () {
  'use strict';

  // Walk up from the button and take the first ancestor that holds a media
  // box — near enough to stay inside this card, so a rail of them cannot
  // start the neighbour's video.
  function mediaFor(button) {
    var media = button.closest('[data-video]');
    var scope = button.parentElement;
    while (!media && scope) {
      media = scope.querySelector('[data-video]');
      scope = scope.parentElement;
    }
    return media;
  }

  function mark(media, playing) {
    media.toggleAttribute('data-video-playing', playing);
    var video = media.querySelector('video');
    // The native controls belong to the playing state. Paused, the frame draws
    // its own play mark over them, so they would only sit there dead.
    if (video) video.controls = playing;
  }

  function start(media) {
    var video = media.querySelector('video');
    if (video) {
      // Already swapped in and paused — pick up where it stopped.
      var resumed = video.play();
      if (resumed && typeof resumed.catch === 'function') resumed.catch(function () {});
      return;
    }

    var tpl = media.querySelector('[data-video-player]');
    if (!tpl) return;
    var node = tpl.content.firstElementChild.cloneNode(true);
    media.appendChild(node);
    tpl.remove();

    if (node.tagName !== 'VIDEO') {
      // An embed plays inside its own frame and never tells us it was paused,
      // so the card stays in its playing state from here on.
      media.setAttribute('data-video-playing', '');
      return;
    }

    node.addEventListener('play', function () { mark(media, true); });
    node.addEventListener('pause', function () { mark(media, false); });
    node.addEventListener('ended', function () { mark(media, false); });

    mark(media, true);
    var started = node.play();
    if (started && typeof started.catch === 'function') {
      started.catch(function () { mark(media, false); });
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var button = target.closest('[data-video-play]');
    if (!button) return;
    var media = mediaFor(button);
    if (!media) return;
    event.preventDefault();
    start(media);
  });
})();
